import { render, staticRenderFns } from "./StandartTemplate.vue?vue&type=template&id=182e7cb6"
import script from "./StandartTemplate.vue?vue&type=script&lang=ts"
export * from "./StandartTemplate.vue?vue&type=script&lang=ts"
import style0 from "./StandartTemplate.vue?vue&type=style&index=0&id=182e7cb6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports